export { getUpsellCopy } from './stackability-common-index';
